import axios from 'axios';
import { IEmail } from '../model/Email';

const API_URL = "/api/v1";

const sendMail = async (formData: IEmail): Promise<void> => {
  const resp = await axios.post(API_URL + "/contact", formData);
  return resp.data;
};

const mailService = {
  sendMail
}

export default mailService;